/**
 * @ngdoc controller
 * @name RootController
 * @description
 * This component renders the main page.
 *
 * @memberof rootModule
 */
class RootController {
  /**
   * Class constructor
   * @param {Service} $location    To redirect the user when the app needs to be updated.
   * @param {Service} $window      If analytics are enabled, the controller needs to access the
   *                               `ga` object on the `window` in order to start the connection.
   * @param {Object}  appConstant  To validate if the GA connection should be made.
   * @param {Service} appUpdates   To listen for changes that require the app to be updated.
   * @param {Service} ccaSession   To get the active section.
   * @ignore
   */
  constructor(
    $location,
    $window,
    appConstant,
    appUpdates,
    ccaSession,
  ) {
    'ngInject';

    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `$window` service.
     * @type {Object}
     */
    this.$window = $window;
    /**
     * The local reference to the `appConstant` constant.
     * @type {Object}
     */
    this.appConstant = appConstant;
    /**
     * The local reference to the `appUpdates` service.
     * @type {Object}
     */
    this.appUpdates = appUpdates;
    /**
     * The local reference to the `ccaSession` service.
     * @type {Object}
     */
    this.ccaSession = ccaSession;
  }
  /**
   * Initialize variables
   */
  $onInit() {
    const { analytics } = this.appConstant.features;
    if (analytics.enabled && this.$window.ga) {
      this.$window.ga('create', analytics.id, 'auto');
    }

    // When the app needs to be updated, load the logout route.
    this.appUpdates.onNewUpdate(() => {
      this.$location.url('/logout?updated=true');
    });
  }
}

export default RootController;



// WEBPACK FOOTER //
// ./src/frontend/modules/root/components/root/root.controller.js